interface TrialFormData {
  action: string
  fields: Record<string, string | null | undefined>
}

export const submitTrialForm = (formData: TrialFormData): void => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = formData.action

  Object.entries(formData.fields).forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value || ''
    form.appendChild(input)
  })

  document.body.appendChild(form)
  form.submit()
}
